import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth); // Faz logout no Firebase
      navigate('/login');  // Redireciona para a tela de login
    } catch (err) {
      console.error('Erro ao fazer logout:', err);
    }
  };

  return (
    <div>
      <button onClick={handleLogout} className="w-full p-2 bg-red-500 text-white rounded">
        Sair
      </button>
    </div>
  );
};

export default Logout;
